/* eslint-disable */
import Header from "components/Common/Header/Header";
import SubscriptionListBody from "components/SubscriptionComponents/SubscriptionListBody/SubscriptionListBody";
import React, { useEffect } from "react";

const Subscription = () => {
  // -------- for title ------------
  useEffect(() => {
    document.title = "Subscription";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="subscription" />

      {/* --------- body section ------------ */}
      <SubscriptionListBody />
    </main>
  );
};

export default Subscription;
